export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Consigne bouteille',
    },
    product_type: {
      label: 'Type de produit',
      options: {
        packaged: 'Emballé',
        prepared: 'Préparé',
      },
    },
    packaging_material: {
      label: "Matériau d'emballage",
    },
    brand_or_manufacturer: {
      label: 'Marque ou fabricant',
    },
    net_quantity: {
      label: 'Quantité nette',
    },
    base_price: {
      label: "Définir le prix à l'unité (ex. par litre pour une boisson)",
      placeholder: "Prix à l'unité",
    },
    alcohol_by_volume_percent: {
      label: 'Teneur en alcool',
    },
    caffeine_mg_per_100ml: {
      label: 'Caféine (mg pour 100 ml de produit)',
    },
    ingredients_text: {
      label: 'Ingrédients',
    },
    allergens_list: {
      label: 'Allergènes',
    },
    additives_list: {
      label: 'Additifs',
    },
    has_nutrition_table: {
      label: 'Remplir le tableau nutritionnel (pour 100{{unit}} de produit)',
    },
    energy_kj: {
      label: 'Énergie (kJ)',
    },
    energy_kcal: {
      label: 'Énergie (kcal)',
    },
    fat_g: {
      label: 'Matières grasses',
    },
    saturates_g: {
      label: 'Acides gras saturés',
    },
    carbohydrate_g: {
      label: 'Glucides',
    },
    sugars_g: {
      label: 'Sucres',
    },
    protein_g: {
      label: 'Protéines',
    },
    salt_g: {
      label: 'Sel',
    },
    identifiers: {
      label: 'Identifiants',
    },
  },
};
